module.exports = __webpack_public_path__ + "img/gpsSearchingLocation.11b4139e.gif";